if (!customElements.get("wls-dynamic-tabs")) {
  class WLSDynamicTabs extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        tabActive: "wls-dynamic-tabs__tab--active",
        tabContentActive: "wls-dynamic-tabs__tab-content--active",
      };

      this.dataAttrs = {
        tabButton: "data-tab-button",
        tabContent: "data-tab-content",
        tabId: "data-tab-id",
        tabImage: "data-tab-image",
      };

      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener("click", this.onClick);

      // Refresh accordion heights after a short delay to ensure wls-accordion has initialized
      setTimeout(() => {
        this.refreshAccordionHeights(this);
      }, 100);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.onClick);
    }

    onClick(e) {
      const tabBtn = e.target.closest(`[${this.dataAttrs.tabButton}]`);
      if (tabBtn && this.contains(tabBtn)) {
        e.preventDefault();
        const tabId = tabBtn.getAttribute(this.dataAttrs.tabId);
        if (tabId) this.switchTab(tabId);
      }
    }

    switchTab(tabId) {
      const buttons = this.querySelectorAll(`[${this.dataAttrs.tabButton}]`);
      const contents = this.querySelectorAll(`[${this.dataAttrs.tabContent}]`);
      const images = this.querySelectorAll(`[${this.dataAttrs.tabImage}]`);

      buttons.forEach((b) => b.classList.remove(this.classes.tabActive));
      contents.forEach((c) => c.classList.remove(this.classes.tabContentActive));
      images.forEach((img) => (img.style.display = "none"));

      const activeBtn = this.querySelector(
        `[${this.dataAttrs.tabButton}][${this.dataAttrs.tabId}="${tabId}"]`
      );
      const activeContent = this.querySelector(
        `[${this.dataAttrs.tabContent}][${this.dataAttrs.tabId}="${tabId}"]`
      );
      const activeImage = this.querySelector(`[${this.dataAttrs.tabImage}="${tabId}"]`);

      if (activeBtn) activeBtn.classList.add(this.classes.tabActive);
      if (activeContent) activeContent.classList.add(this.classes.tabContentActive);
      if (activeImage) activeImage.style.display = "";

      requestAnimationFrame(() => {
        this.refreshAccordionHeights(activeContent);
      });
    }

    refreshAccordionHeights(scopeEl) {
      if (!scopeEl) return;
      
      const accordions = scopeEl.querySelectorAll('wls-accordion');
      accordions.forEach(accordion => {
        const allItems = accordion.querySelectorAll('wls-accordion-item');
        allItems.forEach(item => {
          const content = item.querySelector('wls-accordion-content');
          const trigger = item.querySelector('wls-accordion-trigger');
          const isExpanded = item.hasAttribute('data-expanded') || item.getAttribute('data-expanded') === 'true';
          const hasDefaultOpen = item.hasAttribute('data-default-open-index');
          
          if (content) {
            if (isExpanded || (hasDefaultOpen && item === allItems[0])) {
              const height = content.scrollHeight;
              if (height > 0) {
                content.style.maxHeight = `${height}px`;
                item.setAttribute('data-expanded', 'true');
                if (trigger) trigger.setAttribute('aria-expanded', 'true');
              } else {
                setTimeout(() => {
                  const retryHeight = content.scrollHeight;
                  if (retryHeight > 0) {
                    content.style.maxHeight = `${retryHeight}px`;
                    item.setAttribute('data-expanded', 'true');
                    if (trigger) trigger.setAttribute('aria-expanded', 'true');
                  }
                }, 50);
              }
            }
          }
        });
      });
    }
  }

  customElements.define("wls-dynamic-tabs", WLSDynamicTabs);
}
